import { createContentfulComponent } from "frontend/contentful/lib/create-contentful-component";
import { StatisticsRowEntry } from "frontend/contentful/schema/blocks";
import {
  StatisticsRow,
  StatisticsRowProps,
} from "design-system/components/blocks/statistics-row/statistics-row";
import { createComponentHeaderProps } from "../primitives/component-header.props";
import { createStatisticProps } from "../semantics/statistic.props";

interface StatisticsRowOptions {
  headerAbove?: boolean;
}

export const ContentfulStatisticsRow = createContentfulComponent<
  StatisticsRowEntry,
  StatisticsRowOptions
>(({ entry, options }) => {
  const headerAbove = options?.headerAbove || false;

  const props: StatisticsRowProps = {
    headerContent: createComponentHeaderProps(entry.fields.header),
    align: entry.fields.alignment,
    theme: entry.fields.theme,
    statistics: [],
    HeadingLevel: headerAbove ? "h3" : "h2",
  };

  entry.fields.statistics?.forEach((entry) => {
    const statisticProps = createStatisticProps(entry);
    if (statisticProps) props.statistics?.push(statisticProps);
  });

  return <StatisticsRow {...props} />;
});
